import React from "react";
import Form from "../forms/form";
import { IoMdCheckmark } from "react-icons/io";
import { IoCloseSharp } from "react-icons/io5";
import MyCountdown from "../parts/countdown";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import FormatBackground from '../../img/fon-formats.webp';
import AfterFormats from '../../img/after-format.webp';

import FormatIcon from '../../img/themes-icon/format-icon.svg';

function Formats({formatsData}) {

    const formatText = 'Формат участі';

    return (
        formatsData ?
            formatsData.map((item, index) => (
                <section className="mb-16 md:mb-28" key={index}>
                    <div className="container max-w-screen-lg mx-auto px-[15px]">

                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h2 className="font-bold uppercase text-3xl text-center text-[#245864] mb-10
                                sm:text-4xl lg:text-[60px] md:mb-16">{formatText}</h2>
                        </ScrollAnimation>

                        {
                            item.format.map((item, index) => (
                                <div className="md:flex md:justify-between gap-6 mb-10 md:mb-24">
                                    <div className="relative overflow-hidden pl-6 pr-8 pb-11 pt-[100px] mb-6 bg-[#f4f4f4] rounded-[6px]
                                        md:mb-0 md:w-1/2 md:max-w-[510px] lg:pt-[120px] lg:pl-10 pr-14">
                                        <ScrollAnimation animateIn="animate__fadeInUp"><h3
                                            className="text-[#245864] font-bold uppercase text-2xl mb-6
                                                md:text-3xl md:mb-10">Standart</h3>
                                        </ScrollAnimation>

                                        <ScrollAnimation animateIn="animate__fadeInUp">
                                            <ul>
                                                {item.format_items.map((item, index) => (
                                                    <li className="flex gap-5 mb-3 last:mb-0" key={index}>
                                                        {item.forat_checkbox && (
                                                            <img
                                                                src={FormatIcon}
                                                                alt="icon"
                                                                className="w-[16px] h-[13px] mt-2"
                                                            />
                                                        )}
                                                        <span className="font-normal text-base text-[#245864]">{item.forat_item}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </ScrollAnimation>

                                        <div className="absolute top-0 right-0 w-[90%] h-[130px] z-10 lg:h-[158px]" style={{
                                            backgroundImage: `url(${FormatBackground})`,
                                            backgroundSize: 'contain',
                                            backgroundPosition: 'top right',
                                            backgroundRepeat: 'no-repeat'
                                        }}/>
                                    </div>
                                    <div id="formats" className="bg-white pt-7 px-4 pb-8 md:w-1/2 md:max-w-[415px] md:bg-transparent">
                                        <Form nameform="form_uchast_intext_done"/>
                                    </div>
                                </div>
                            ))
                        }
                        <img src={AfterFormats} alt="Івент ШІ"/>

                    </div>
                </section>)) : ''
    )
}

export default Formats